import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import { useTranslations } from 'use-intl';

// Fallback translations when intl context is not available
const fallbackTranslations: Record<string, string> = {
  'error.404_title': 'Page not found',
  'error.404_desc': 'The page you are looking for does not exist.',
  'error.go_back': 'Go back',
  'error.back_to_home': 'Back to home',
};

function NotFoundErrorContent({ translations }: { translations?: ReturnType<typeof useTranslations> }) {
  const navigate = useNavigate();
  const t = (key: string) => (translations ? translations(key) : fallbackTranslations[key] || key);

  return (
    <div className="h-svh">
      <div className="m-auto flex h-full w-full flex-col items-center justify-center gap-2">
        <h1 className="text-[7rem] font-bold leading-tight">404</h1>
        <span className="font-medium">{t('error.404_title')}</span>
        <p className="text-center text-muted-foreground">{t('error.404_desc')}</p>
        <div className="mt-6 flex gap-4">
          <Button variant="outline" onClick={() => navigate(-1)}>
            {t('error.go_back')}
          </Button>
          <Button onClick={() => navigate('/')}>{t('error.back_to_home')}</Button>
        </div>
      </div>
    </div>
  );
}

function NotFoundErrorWithTranslations() {
  const translations = useTranslations();
  return <NotFoundErrorContent translations={translations} />;
}

export default function NotFoundError() {
  // Try to render with translations, fall back to without if context is missing
  try {
    return <NotFoundErrorWithTranslations />;
  } catch {
    return <NotFoundErrorContent />;
  }
}
